<template>
  <popper :visible-arrow="false" :trigger="trigger" :options="options">
    <div class="popper">
      {{ text }}
    </div>

    <template slot="reference">
      <slot />
    </template>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs';

// @vuese
// ToolTip
// @group Tooltip
export default {
  name: 'Tooltip',
  components: {
    Popper
  },
  props: {
    // Text do wyświetlenia w Tooltip
    text: {
      type: String,
      required: true
    },
    // Miejsce ustawienia:
    // bottom,left,right,top,auto
    placement: {
      type: String,
      default: 'top',
      required: false
    },
    // Na jaki event wyświetlić:
    // hover,click,focus
    trigger: {
      type: String,
      default: 'hover',
      required: false
    }
  },
  data() {
    return {
      options: {
        placement: this.placement,
        modifiers: { offset: { offset: '0,5px' } }
      }
    };
  }
};
</script>

<style>
.popper {
  padding: 3px;
  font-size: 14px;
  background: white;
  border: 1px solid #ccc;
  -webkit-box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.26);
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.26);
}
</style>
